// import { store } from './store/store';

export default {
  install(Vue) {
    Vue.mixin({
      data: function () {
        return {
          $token: null
        };
      },
      methods: {
        $alertMsg(content, title = '', getButtonEvent = () => {}, btnName) {
          this.$eventBus.$emit('DialogPopup', {
            useDialog: true,
            messageHTML: title ? `<dl class="txt"><dt>${title}</dt><dd>${content}</dd></dl>` : `<p class="txt">${content}</p>`,
            getBtnName: !btnName ? '확인' : btnName,
            getButtonEvent: () => getButtonEvent()
          });
        },
        $threeBtnPopup(opts = {}) {
          try {
            const defaults = {
              useDialog: true,
              persistent: true,
              getWidth: 400,
              messageHTML: '',
              getBtnName: '확인',
              getLeftBtnName: '취소',
              getRightBtnName: '',
              getButtonEvent: () => {},
              getLeftBtnEvent: () => {},
              getRightBtnEvent: () => {},
              isLoading: false
            };
            const payload = Object.assign({}, defaults, opts || {});
            try {
              this.$eventBus.$emit('ThreeBtnDialogPopup', payload);
            } catch (e) {
              console.log('ThreeBtnDialogPopup emit error:', e);
            }
          } catch (e) {
            console.log(e);
          }
        },
        $confirmMsg(title, content, getButtonEvent = () => {}, btnName, getLeftBtnEvent = () => {}, leftBtnName, useReverse = false) {
          this.$eventBus.$emit('DialogPopup', {
            useDialog: true,
            getBtnCount: 2,
            getBtnName: !btnName ? '저장' : btnName,
            getLeftBtnName: !leftBtnName ? '취소' : leftBtnName,
            getButtonEvent: () => getButtonEvent(),
            getLeftBtnEvent: () => getLeftBtnEvent(),
            messageHTML: title ? `<dl class="txt"><dt>${title}</dt><dd>${content}</dd></dl>` : `<p class="txt">${content}</p>`,
            useReverse
          });
        },
        $checkAction(pms) {
          try {
            if (localStorage.getItem('agent-authority')) {
              const menus = JSON.parse(localStorage.getItem('agent-authority')).menus;
              for (const roleMenus of Object.keys(menus)) {
                if (menus[roleMenus].indexOf(pms) >= 0) {
                  return true;
                }
              }
              return false;
            } else {
              return false;
            }
          } catch (e) {
            return false;
          }
        },
        $showMaxCharErrorToast(value, limit) {
          if (value.length >= limit) {
            this.$toasted.clear();
            this.$toasted.error('최대 입력 글자수가 초과되었습니다.');
          }
        }
      }
    });
  }
};



// WEBPACK FOOTER //
// ./src/GlobalEvent.js